var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modelling"},[_c('div',{staticClass:"modelling__panel"},[_c('router-view')],1),_c('div',{staticClass:"modelling__map"},[_c('m-map'),(_vm.routeName === 'm-scenario' && _vm.times.length)?_c('m-timeline'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }